/**
 * Normalize phone-like values for stable comparison across formatting styles.
 * Examples treated as equivalent:
 * - "(512) 634-8845"
 * - "+15126348845"
 * - "5126348845"
 */
export const normalizePhoneForComparison = (
  value?: string | null,
): string | null => {
  if (!value) return null

  const digitsOnly = value.replace(/\D/g, '')
  if (!digitsOnly) return null

  // Normalize NANP-style leading country code for dedupe/matching.
  // Intentional scope: this utility is for switchboard SMS comparison where
  // we currently treat NANP formatting variants as equivalent.
  // Non-NANP numbers are still compared by full digit string.
  if (digitsOnly.length === 11 && digitsOnly.startsWith('1')) {
    return digitsOnly.slice(1)
  }

  return digitsOnly
}

export const areEquivalentPhoneNumbers = (
  left?: string | null,
  right?: string | null,
): boolean => {
  const normalizedLeft = normalizePhoneForComparison(left)
  const normalizedRight = normalizePhoneForComparison(right)
  return Boolean(
    normalizedLeft && normalizedRight && normalizedLeft === normalizedRight,
  )
}
